import { Directive, Input, OnInit, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';

@Directive({
    selector: '[appHasPermission]',
    standalone: false,
})
export class HasPermissionDirective implements OnInit {
    private viewContainer = inject(ViewContainerRef);
    private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
    private permissionsService = inject(PermissionsService);

    @Input('appHasPermission') public hasPermission: string;

    public ngOnInit() {
        const permissions = this.hasPermission.split(',').map((p) => p.trim());
        const hasPermissions = this.permissionsService != null && this.permissionsService.hasPermissions(permissions);
        if (hasPermissions) {
            const result = this.viewContainer.createEmbeddedView(this.templateRef);
            result.detectChanges();
        }
    }
}
